import React, { useMemo } from 'react'

import { Box, Color, Space, ZIndex } from '@gousto-internal/citrus-react'
import {
  AboveTheFoldSection,
  BrandEndorsementsSection,
  CustomerReviewsSection,
  DiscountBanner,
  DiscountPerWeek,
  EndlessVarietySection,
  HeroTitle,
  HowItWorksSection,
  OurSuppliersSection,
  ValueYouCanTasteSection,
} from '@library/landing-pages'
import type { HeroSlidesConfig } from '@library/landing-pages'
import type { Recipe } from '@library/menu-service'

import { usePaidSearchBrandDiscountBoxes } from '../hooks/usePaidSearchBrandDiscountBoxes'
import { heroGetStartedTrackingEvent } from '../tracking/trackingConfig'
import { redirectToWizard } from '../util/redirectToWizard'

export type PaidSearchBrandPageProps = {
  recipes: Recipe[]
  signupCTA: string
  signupCTAUri: string
}

const getHeroSlides = (): HeroSlidesConfig => ({
  titlePart1: "The UK's",
  titlePart2: 'best recipe',
  titlePart3: 'box for',
  titlePart4: 'choice*',
  subTitlePart1Mobile: 'Discover our biggest menu ever',
  subTitlePart2Mobile: 'with 175+ recipes every week',
  subTitlePart3Mobile: '',
  subTitlePart1Desktop: 'Discover our biggest menu ever',
  subTitlePart2Desktop: 'with 175+ recipes every week',
})

export const PaidSearchBrandPage = ({
  recipes,
  signupCTA,
  signupCTAUri,
}: PaidSearchBrandPageProps) => {
  const paidSearchBrandHeroSlides = useMemo(() => getHeroSlides(), [])
  const paidSearchBrandDiscountBoxes = usePaidSearchBrandDiscountBoxes()
  const redirectToPaidSearchWizard = () =>
    redirectToWizard(heroGetStartedTrackingEvent(), signupCTAUri)

  return (
    <Box paddingBottom={[10, 6]} bg={Color.White}>
      <AboveTheFoldSection
        onCTAClick={redirectToPaidSearchWizard}
        signupCTA={signupCTA}
        heroSlides={paidSearchBrandHeroSlides}
        heroTitleBox={
          <Box width={['348px', null, null, '460px']} zIndex={ZIndex.Mask}>
            <Space size={[14, null, 18]} />
            <HeroTitle slides={paidSearchBrandHeroSlides} suffix={null} />
          </Box>
        }
        discountBanner={
          <DiscountBanner onBannerCTAClick={redirectToPaidSearchWizard} title="Your offer">
            <DiscountPerWeek boxes={paidSearchBrandDiscountBoxes} />
          </DiscountBanner>
        }
      />
      <CustomerReviewsSection />
      <HowItWorksSection signupCTA={signupCTA} onCTAClick={redirectToPaidSearchWizard} />
      <ValueYouCanTasteSection signupCTA={signupCTA} onCTAClick={redirectToPaidSearchWizard} />
      <EndlessVarietySection
        signupCTA={signupCTA}
        onCTAClick={redirectToPaidSearchWizard}
        recipes={recipes}
      />
      <BrandEndorsementsSection />
      <OurSuppliersSection />
    </Box>
  )
}
